import Vue from 'vue';

/**
 * 通用翻译
 * @param value
 * @param dictType
 * @returns {*}
 */
export const commonTranslate = (value, dictType) => {
  return window.utils.dict.get(dictType, {
    dictValue:
      value?.toString() || ''
  }).dictName;
};
/**
 * 车型翻译
 * @param value 字典值
 * @returns {string}
 */
export const identifyType = value => {
  return commonTranslate(value, 'dict_identifyType_option');
};

/**
 * 危化品类型名称翻译
 * @param value
 * @returns {*}
 */
export const dangerous = value => {
  return commonTranslate(value, 'dict_dangerous_option');
};
/**
 * 字典翻译快捷工具
 * @type {{identityType: (function(*): *)}}
 */
window.translate = {
  commonTranslate,
  identifyType,
  dangerous,
};

Vue.prototype.$translate = window.translate;
